import { useCallback, useRef } from "react";
import { usePostHogClient } from "./ProductAnalyticsProvider";

export type DomainEmailSetupMode = "owned_postmark" | "shared_postmark" | "nylas";

type AnalyticsProperty = string | number | boolean | string[] | null | undefined;
export type ProductAnalyticsEventProperties = Record<string, AnalyticsProperty>;

export function useProductAnalytics(
  defaultProperties: ProductAnalyticsEventProperties = {},
): (event: string, properties?: ProductAnalyticsEventProperties) => void {
  const posthog = usePostHogClient();
  const defaultPropertiesRef = useRef(defaultProperties);
  defaultPropertiesRef.current = defaultProperties;

  return useCallback(
    (event: string, properties: ProductAnalyticsEventProperties = {}) => {
      posthog?.capture(event, {
        ...defaultPropertiesRef.current,
        ...properties,
        schema_version: 1,
      });
    },
    [posthog],
  );
}
